import React from 'react';
import { StyleSheet } from 'react-native';

import { getRoutes, NavigationItem } from '../Navigation';
import { sizes, themeColors } from '../uiold/Constants';
import { HiddenPrintView } from '../uiold/HiddenPrintView';

import { useAuthState } from '../AuthState';

export default function MainNav() {
  const { account, user } = useAuthState();

  const routes = getRoutes(account);

  return (
    <HiddenPrintView style={styles.root}>
      {routes.map((route, i) => (
        <NavigationItem key={i} user={user} account={account} route={route} />
      ))}
    </HiddenPrintView>
  );
}

const styles = StyleSheet.create({
  root: {
    backgroundColor: themeColors.mainNavBackground,
    paddingVertical: 25,
    width: sizes.navWidth,
    maxWidth: sizes.navWidth,
    overflowY: 'scroll',
  },
});
